module.exports = __webpack_public_path__ + "img/employees_title.7da4210e.svg";